import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatMenuModule } from '@angular/material/menu';
import { FilterableItemsListModule } from '@y42/core/filterable-items-list';
import { IconModule } from '@y42/core/icon';
import { StopPropagationModule } from '@y42/core/stop-propagation';
import { TagsCellRendererComponent } from './tags-cell-renderer.component';

@NgModule({
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    IconModule,
    FilterableItemsListModule,
    StopPropagationModule,
    MatIconModule,
  ],
  declarations: [TagsCellRendererComponent],
  exports: [TagsCellRendererComponent],
})
export class TagsCellRendererModule {}
